const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const NAV_LINKS = [
  { id: 'home', label: 'Home' },
  { id: 'health-dimensions-section', label: 'tots360' },
  { id: 'tools-section', label: 'Tools' },
  { id: 'how-it-works-section', label: 'The Process' },
  { id: 'contact', label: 'Contact' }
];

export const scrollTo = (id) => {
  document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
};
